<template>
  <el-dialog
    top="0"
    class="dialog-full-medium"
    width="30%"
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <div class="dialog__body">
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="城市名称" prop="cityNo">
          <jr-select
            v-model="form.cityName"
            placeholder="请选择城市"
            :size="formSize"
            :options="creditCityList"
            :propsConfig="{ value: 'code', label: 'codeName'}"
            value-key="codeName"
            :hasAll="false"
            :is-bind-obj="true"
            select-style="width: 100%"
            @change="handleCityChange"
          />
        </el-form-item>

        <el-form-item label="保证金金额" prop="deposit">
          <el-input placeholder="请输入" v-model="form.deposit" v-number-only:2="form.deposit" :size="formSize" :maxlength="12" />
        </el-form-item>

        <el-form-item label="保证金占比" prop="depositRate">
          <div class="jr_flex_amount">
            <el-input placeholder="请输入" v-model="form.depositRate" v-number-only:2="form.depositRate" :size="formSize" :maxlength="5" />
            <div class="jr_flex_amount_unit">%</div>
          </div>
        </el-form-item>

        <el-form-item label="城市总授信额度" required="">
          <el-input :value="totalCreditQuota | toThousands" disabled :size="formSize" />
        </el-form-item>

        <el-form-item label="授信状态:" prop="creditStatus">
          <el-radio-group v-model="form.creditStatus">
            <el-radio label="ON">启用</el-radio>
            <el-radio label="OFF">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose()" :size="formSize">取消</el-button>
      <el-button type="primary" :size="formSize" :loading="submitLoading" @click="submit()">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import NP from 'number-precision';
import { getCityDetail, addCitybop, editCitybop } from '@/api/baibu-bill';
import { regFenToYuan, regYuanToFen } from '@/utils/number';

const defaultForm = {
  cityId: '', // 城市id
  cityName: '', // 城市名称
  cityNo: '', // 城市编号
  creditQuota: '', // 授信额度(分)
  creditStatus: '', // 授信状态
  deposit: '', // 保证金(分)
  depositRate: '', // 保证金占比(%)
};
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isModify: {
      type: Boolean,
      default: false,
    },
    cityId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    const validateDepositRate = (rule, value, callback) => {
      if (!value && value !== 0) {
        callback(new Error('请输入'));
      } else if (Number(value) <= 0) {
        callback(new Error('请输入大于0的数字'));
      } else {
        callback();
      }
    };
    return {
      title: '城市额度',
      submitLoading: false,
      form: JSON.parse(JSON.stringify(defaultForm)),
      rules: {
        cityNo: [{ required: true, message: '请选择', trigger: 'change' }],
        deposit: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: validateDepositRate, trigger: 'blur' },
        ],
        depositRate: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: validateDepositRate, trigger: 'blur' },
        ],
        creditQuota: [{ required: true, message: '请输入', trigger: 'blur' }],
        creditStatus: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      cardConfigDict: '/finance/finance-receipt/CreditCity',
    };
  },
  computed: {
    // 城市总授信额度 = 保证金/(占比/100)
    totalCreditQuota() {
      if (this.form.deposit && this.form.depositRate && this.form.depositRate !== '0') {
        const totalNumber = (NP.divide(this.form.deposit, NP.divide(this.form.depositRate, 100)) ?? 0).toFixed(2);
        return totalNumber;
      }
      return '';
    },
    // 授信城市list
    creditCityList() {
      const { dictData } = this.$store.state.dictionary;
      if (dictData) {
        return dictData[this.cardConfigDict] || [];
      }
      return [];
    },
  },
  methods: {
    // 选择城市返回
    handleCityChange(val) {
      this.form.cityNo = val.code;
      this.form.cityName = val.codeName;
    },
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
      this.submitLoading = false;
    },
    // 打开窗口前
    handleOpen() {
      // 获取字典
      this.$store.dispatch({ type: 'dictionary/getDictionaryPath', paths: [this.cardConfigDict] });
      this.$nextTick(async () => {
        this.title = `${this.isModify ? '编辑' : '新增'}城市额度`;
        if (this.isModify) {
          this.form = JSON.parse(JSON.stringify(defaultForm));
          this.handleDetail(this.cityId);
        } else {
          this.form = JSON.parse(JSON.stringify(defaultForm));
        }
        this.$refs.form.resetFields();
      });
    },
    // 提交
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const params = JSON.parse(JSON.stringify(this.form));
            // 元转分
            params.deposit = regYuanToFen(params.deposit);
            params.creditQuota = regYuanToFen(this.totalCreditQuota);
            this.submitLoading = true;
            if (this.isModify) {
              // 修改
              await editCitybop(params);
            } else {
              // 新增
              await addCitybop(params);
            }
            this.$message.success(`${this.isModify ? '编辑' : '新增'}成功！！`);
            this.submitLoading = false;
            this.handleClose();
            this.$emit('success');
          } catch (error) {
            console.log(error);
            this.submitLoading = false;
          }
        }
      });
    },
    async handleDetail(cityId) {
      try {
        const res = await getCityDetail({ cityId });
        const data = res.data || {};
        Object.keys(defaultForm).forEach((key) => {
          if (key === 'deposit' && (data.deposit || data.deposit === 0)) {
            this.form.deposit = regFenToYuan(data.deposit ?? 0);
          } else {
            this.form[key] = data[key] || '';
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
  },

};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    min-width: 500px;
  }
  .content {
    margin-right: 0;
  }
  .el-input.is-disabled .el-input__inner {
    color: #4D4F51;
  }
}

.jr_flex_amount {
  display: flex;
  align-items: center;
  .jr_flex_amount_unit {
    margin-left: 10px;
  }

}
</style>
